import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PrinterSelectorComponent } from './printer-selector.component';
import { NbSpinnerModule } from '@nebular/theme';
import { FormsModule } from '@angular/forms';
import { MultiSelectAllModule } from '@syncfusion/ej2-angular-dropdowns';
import { MatOptionModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';

@NgModule({
  declarations: [
    PrinterSelectorComponent
  ],
  exports: [
    PrinterSelectorComponent
  ],
  // entryComponents: [

  // ],
  imports: [
    CommonModule,
    NbSpinnerModule,
    MatFormFieldModule,
    MatSelectModule,
    MatOptionModule,
    NgxMatSelectSearchModule,
    FormsModule,
    MultiSelectAllModule
  ]
})
export class PrinterSelectorModule { }
